
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as aboutJnSbF7NuFyMeta } from "/workspace/layers/website/pages/about.vue?macro=true";
import { default as index4YF2hZIZGkMeta } from "/workspace/layers/admin-panel/pages/admin/about/index.vue?macro=true";
import { default as company_45games7KrpUOKXjdMeta } from "/workspace/layers/admin-panel/pages/admin/analytics/dashboards/company-games.vue?macro=true";
import { default as indexqmqQoGgdeNMeta } from "/workspace/layers/admin-panel/pages/admin/analytics/dashboards/genres/[genre]/[subgenre]/index.vue?macro=true";
import { default as indexucIG5AwuvxMeta } from "/workspace/layers/admin-panel/pages/admin/analytics/dashboards/genres/[genre]/index.vue?macro=true";
import { default as index7OK4SKxo2rMeta } from "/workspace/layers/admin-panel/pages/admin/analytics/dashboards/genres/index.vue?macro=true";
import { default as platform_45overviewl1lqt5bkKTMeta } from "/workspace/layers/admin-panel/pages/admin/analytics/dashboards/platform-overview.vue?macro=true";
import { default as up_45and_45comingq3p7UcQEFjMeta } from "/workspace/layers/admin-panel/pages/admin/analytics/up-and-coming.vue?macro=true";
import { default as indexJTiWalWIa8Meta } from "/workspace/layers/admin-panel/pages/admin/auth/index.vue?macro=true";
import { default as index_45old25GlsYROISMeta } from "/workspace/layers/admin-panel/pages/admin/careers/index-old.vue?macro=true";
import { default as indexCwwEAcwWngMeta } from "/workspace/layers/admin-panel/pages/admin/careers/index.vue?macro=true";
import { default as _91jobId_93joDN1S7ruUMeta } from "/workspace/layers/admin-panel/pages/admin/careers/pages/[jobId].vue?macro=true";
import { default as indexMqGsJH3WFJMeta } from "/workspace/layers/admin-panel/pages/admin/contact/index.vue?macro=true";
import { default as indexuj89DtoKXQMeta } from "/workspace/layers/admin-panel/pages/admin/games/[id]/analytics/index.vue?macro=true";
import { default as editLjGhPt5ftmMeta } from "/workspace/layers/admin-panel/pages/admin/games/[id]/edit.vue?macro=true";
import { default as addBV8Hl7p4KAMeta } from "/workspace/layers/admin-panel/pages/admin/games/add.vue?macro=true";
import { default as analyticsydlPesqaYiMeta } from "/workspace/layers/admin-panel/pages/admin/games/analytics.vue?macro=true";
import { default as index5Bbr8gJlVGMeta } from "/workspace/layers/admin-panel/pages/admin/games/index.vue?macro=true";
import { default as indexxz2hFTeC5uMeta } from "/workspace/layers/admin-panel/pages/admin/homepage/index.vue?macro=true";
import { default as indextfGvR6yg7RMeta } from "/workspace/layers/admin-panel/pages/admin/index.vue?macro=true";
import { default as _91articleId_939Pr9kXLPcHMeta } from "/workspace/layers/admin-panel/pages/admin/news/[articleId].vue?macro=true";
import { default as indexq2HJcl5LA2Meta } from "/workspace/layers/admin-panel/pages/admin/news/index.vue?macro=true";
import { default as newt3ZyrOl87qMeta } from "/workspace/layers/admin-panel/pages/admin/news/new.vue?macro=true";
import { default as _91articlePath_93tGcGPOpeLTMeta } from "/workspace/layers/admin-panel/pages/admin/news/page/[articlePath].vue?macro=true";
import { default as _91id_93LXmjGE2L36Meta } from "/workspace/layers/admin-panel/pages/admin/roles/[id].vue?macro=true";
import { default as indexUuoPScHKsSMeta } from "/workspace/layers/admin-panel/pages/admin/roles/index.vue?macro=true";
import { default as newuyqxjvVtJAMeta } from "/workspace/layers/admin-panel/pages/admin/roles/new.vue?macro=true";
import { default as indexTJ2RrEToRzMeta } from "/workspace/layers/admin-panel/pages/admin/settings/index.vue?macro=true";
import { default as _91id_93mkrex0cPZRMeta } from "/workspace/layers/admin-panel/pages/admin/social-media/[id].vue?macro=true";
import { default as index8ZFEmdQaiMMeta } from "/workspace/layers/admin-panel/pages/admin/social-media/index.vue?macro=true";
import { default as newxIJWbnhIv5Meta } from "/workspace/layers/admin-panel/pages/admin/social-media/new.vue?macro=true";
import { default as _91userLogin_93LvtZFabJ2iMeta } from "/workspace/layers/admin-panel/pages/admin/users/[userLogin].vue?macro=true";
import { default as indexisbXxQq3fjMeta } from "/workspace/layers/admin-panel/pages/admin/users/index.vue?macro=true";
import { default as newkeaa4rkOsUMeta } from "/workspace/layers/admin-panel/pages/admin/users/new.vue?macro=true";
import { default as adminufhTf3V0mlMeta } from "/workspace/layers/admin-panel/pages/admin.vue?macro=true";
import { default as _91jobId_93MBpR5RkT5HMeta } from "/workspace/layers/website/pages/careers/[jobId].vue?macro=true";
import { default as indexvzAIzfpcGNMeta } from "/workspace/layers/website/pages/careers/index.vue?macro=true";
import { default as contact_45usupK02AkMfeMeta } from "/workspace/layers/website/pages/contact-us.vue?macro=true";
import { default as index0Ld7sMd1ECMeta } from "/workspace/layers/website/pages/index.vue?macro=true";
import { default as _91articleUrl_93bM09Arnm7aMeta } from "/workspace/layers/website/pages/news/[articleUrl].vue?macro=true";
import { default as indexTYOQZFvgMSMeta } from "/workspace/layers/website/pages/news/index.vue?macro=true";
export default [
  {
    name: "about",
    path: "/about",
    meta: aboutJnSbF7NuFyMeta || {},
    component: () => import("/workspace/layers/website/pages/about.vue")
  },
  {
    name: adminufhTf3V0mlMeta?.name,
    path: "/admin",
    meta: adminufhTf3V0mlMeta || {},
    component: () => import("/workspace/layers/admin-panel/pages/admin.vue"),
    children: [
  {
    name: "admin-about",
    path: "about",
    meta: index4YF2hZIZGkMeta || {},
    component: () => import("/workspace/layers/admin-panel/pages/admin/about/index.vue")
  },
  {
    name: "admin-analytics-dashboards-company-games",
    path: "analytics/dashboards/company-games",
    component: () => import("/workspace/layers/admin-panel/pages/admin/analytics/dashboards/company-games.vue")
  },
  {
    name: "admin-analytics-dashboards-genres-genre-subgenre",
    path: "analytics/dashboards/genres/:genre()/:subgenre()",
    component: () => import("/workspace/layers/admin-panel/pages/admin/analytics/dashboards/genres/[genre]/[subgenre]/index.vue")
  },
  {
    name: "admin-analytics-dashboards-genres-genre",
    path: "analytics/dashboards/genres/:genre()",
    component: () => import("/workspace/layers/admin-panel/pages/admin/analytics/dashboards/genres/[genre]/index.vue")
  },
  {
    name: "admin-analytics-dashboards-genres",
    path: "analytics/dashboards/genres",
    component: () => import("/workspace/layers/admin-panel/pages/admin/analytics/dashboards/genres/index.vue")
  },
  {
    name: "admin-analytics-dashboards-platform-overview",
    path: "analytics/dashboards/platform-overview",
    component: () => import("/workspace/layers/admin-panel/pages/admin/analytics/dashboards/platform-overview.vue")
  },
  {
    name: "admin-analytics-up-and-coming",
    path: "analytics/up-and-coming",
    component: () => import("/workspace/layers/admin-panel/pages/admin/analytics/up-and-coming.vue")
  },
  {
    name: "admin-auth",
    path: "auth",
    meta: indexJTiWalWIa8Meta || {},
    component: () => import("/workspace/layers/admin-panel/pages/admin/auth/index.vue")
  },
  {
    name: "admin-careers-index-old",
    path: "careers/index-old",
    component: () => import("/workspace/layers/admin-panel/pages/admin/careers/index-old.vue")
  },
  {
    name: "admin-careers",
    path: "careers",
    component: () => import("/workspace/layers/admin-panel/pages/admin/careers/index.vue")
  },
  {
    name: "admin-careers-pages-jobId",
    path: "careers/pages/:jobId()",
    component: () => import("/workspace/layers/admin-panel/pages/admin/careers/pages/[jobId].vue")
  },
  {
    name: "admin-contact",
    path: "contact",
    component: () => import("/workspace/layers/admin-panel/pages/admin/contact/index.vue")
  },
  {
    name: "admin-games-id-analytics",
    path: "games/:id()/analytics",
    component: () => import("/workspace/layers/admin-panel/pages/admin/games/[id]/analytics/index.vue")
  },
  {
    name: "admin-games-id-edit",
    path: "games/:id()/edit",
    component: () => import("/workspace/layers/admin-panel/pages/admin/games/[id]/edit.vue")
  },
  {
    name: "admin-games-add",
    path: "games/add",
    component: () => import("/workspace/layers/admin-panel/pages/admin/games/add.vue")
  },
  {
    name: "admin-games-analytics",
    path: "games/analytics",
    component: () => import("/workspace/layers/admin-panel/pages/admin/games/analytics.vue")
  },
  {
    name: "admin-games",
    path: "games",
    component: () => import("/workspace/layers/admin-panel/pages/admin/games/index.vue")
  },
  {
    name: "admin-homepage",
    path: "homepage",
    component: () => import("/workspace/layers/admin-panel/pages/admin/homepage/index.vue")
  },
  {
    name: "admin",
    path: "",
    component: () => import("/workspace/layers/admin-panel/pages/admin/index.vue")
  },
  {
    name: "admin-news-articleId",
    path: "news/:articleId()",
    meta: _91articleId_939Pr9kXLPcHMeta || {},
    component: () => import("/workspace/layers/admin-panel/pages/admin/news/[articleId].vue")
  },
  {
    name: "admin-news",
    path: "news",
    component: () => import("/workspace/layers/admin-panel/pages/admin/news/index.vue")
  },
  {
    name: "admin-news-new",
    path: "news/new",
    meta: newt3ZyrOl87qMeta || {},
    component: () => import("/workspace/layers/admin-panel/pages/admin/news/new.vue")
  },
  {
    name: "admin-news-page-articlePath",
    path: "news/page/:articlePath()",
    component: () => import("/workspace/layers/admin-panel/pages/admin/news/page/[articlePath].vue")
  },
  {
    name: "admin-roles-id",
    path: "roles/:id()",
    component: () => import("/workspace/layers/admin-panel/pages/admin/roles/[id].vue")
  },
  {
    name: "admin-roles",
    path: "roles",
    component: () => import("/workspace/layers/admin-panel/pages/admin/roles/index.vue")
  },
  {
    name: "admin-roles-new",
    path: "roles/new",
    component: () => import("/workspace/layers/admin-panel/pages/admin/roles/new.vue")
  },
  {
    name: "admin-settings",
    path: "settings",
    component: () => import("/workspace/layers/admin-panel/pages/admin/settings/index.vue")
  },
  {
    name: "admin-social-media-id",
    path: "social-media/:id()",
    component: () => import("/workspace/layers/admin-panel/pages/admin/social-media/[id].vue")
  },
  {
    name: "admin-social-media",
    path: "social-media",
    component: () => import("/workspace/layers/admin-panel/pages/admin/social-media/index.vue")
  },
  {
    name: "admin-social-media-new",
    path: "social-media/new",
    component: () => import("/workspace/layers/admin-panel/pages/admin/social-media/new.vue")
  },
  {
    name: "admin-users-userLogin",
    path: "users/:userLogin()",
    component: () => import("/workspace/layers/admin-panel/pages/admin/users/[userLogin].vue")
  },
  {
    name: "admin-users",
    path: "users",
    component: () => import("/workspace/layers/admin-panel/pages/admin/users/index.vue")
  },
  {
    name: "admin-users-new",
    path: "users/new",
    component: () => import("/workspace/layers/admin-panel/pages/admin/users/new.vue")
  }
]
  },
  {
    name: "careers-jobId",
    path: "/careers/:jobId()",
    meta: _91jobId_93MBpR5RkT5HMeta || {},
    component: () => import("/workspace/layers/website/pages/careers/[jobId].vue")
  },
  {
    name: "careers",
    path: "/careers",
    meta: indexvzAIzfpcGNMeta || {},
    component: () => import("/workspace/layers/website/pages/careers/index.vue")
  },
  {
    name: "contact-us",
    path: "/contact-us",
    meta: contact_45usupK02AkMfeMeta || {},
    component: () => import("/workspace/layers/website/pages/contact-us.vue")
  },
  {
    name: "index",
    path: "/",
    meta: index0Ld7sMd1ECMeta || {},
    component: () => import("/workspace/layers/website/pages/index.vue")
  },
  {
    name: "news-articleUrl",
    path: "/news/:articleUrl()",
    meta: _91articleUrl_93bM09Arnm7aMeta || {},
    component: () => import("/workspace/layers/website/pages/news/[articleUrl].vue")
  },
  {
    name: "news",
    path: "/news",
    meta: indexTYOQZFvgMSMeta || {},
    component: () => import("/workspace/layers/website/pages/news/index.vue")
  }
]